/**
 * Quiseya · Barra de anuncio con movimiento continuo hacia la izquierda (marquee).
 *
 * Toma los mensajes de los bloques de anuncio del tema (los 3 slides), los coloca
 * en una pista duplicada [A][A] y la anima en bucle sin costuras a velocidad
 * constante. Oculta los slides originales y las flechas del carrusel.
 * Respeta prefers-reduced-motion y pausa al pasar el ratón / con la pestaña oculta.
 */
(function () {
  'use strict';

  var SPEED_PX_S = 70;      // velocidad del desplazamiento (px por segundo)
  var MIN_HALF_PX = 1300;   // mínimo de una mitad de pista (pantallas anchas)
  var SEP_TEXT = '✦';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function debounce(fn, ms) {
    var t = null;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, ms);
    };
  }

  ready(function () {
    var comp = document.querySelector('announcement-bar-component');
    if (!comp) return;

    var slides = Array.prototype.slice.call(comp.querySelectorAll('.announcement-bar__slide'));
    if (slides.length < 2) return;

    var items = [];
    slides.forEach(function (s) {
      var p = s.querySelector('.announcement-bar__text');
      var a = s.querySelector('.announcement-bar__link');
      if (!p) return;
      var txt = (p.textContent || '').trim();
      if (!txt) return;
      items.push({ html: p.innerHTML.trim(), href: a ? a.getAttribute('href') : null });
    });
    if (items.length < 2) return;

    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var slider = comp.closest('.announcement-bar__slider') || comp;
    var slidesBox = comp.querySelector('.announcement-bar__slides');

    // Contenedor del marquee
    var wrap = document.createElement('div');
    wrap.className = 'qy-mq';
    wrap.setAttribute('role', 'note');

    // Texto accesible estático (una sola vez, sin duplicados)
    var sr = document.createElement('span');
    sr.className = 'visually-hidden';
    sr.textContent = items
      .map(function (i) { return i.html.replace(/<[^>]+>/g, ''); })
      .join(' · ');
    wrap.appendChild(sr);

    var track = document.createElement('div');
    track.className = 'qy-mq-track';
    wrap.appendChild(track);

    function appendSequence(parent, hidable) {
      items.forEach(function (it) {
        var a = document.createElement(it.href ? 'a' : 'span');
        a.className = 'qy-mq-item';
        if (it.href) a.setAttribute('href', it.href);
        if (hidable) a.setAttribute('tabindex', '-1');
        a.innerHTML = it.html;
        parent.appendChild(a);

        var sep = document.createElement('span');
        sep.className = 'qy-mq-sep';
        sep.setAttribute('aria-hidden', 'true');
        sep.textContent = SEP_TEXT;
        parent.appendChild(sep);
      });
    }

    function medidas() {
      var half = track.firstElementChild;
      if (!half) return { halfW: 1, seqW: 1 };
      var seqW = half.getBoundingClientRect().width || half.scrollWidth || 1;
      return { halfW: half.getBoundingClientRect().width || half.scrollWidth || 1, seqW: seqW };
    }

    function build() {
      track.innerHTML = '';

      var half = document.createElement('div');
      half.className = 'qy-mq-half';
      track.appendChild(half);

      appendSequence(half, false);
      var seqW = half.getBoundingClientRect().width || half.scrollWidth || 1;
      var need = Math.max(window.innerWidth, MIN_HALF_PX);
      var reps = Math.max(1, Math.ceil(need / Math.max(seqW, 1)));
      for (var i = 1; i < reps; i++) appendSequence(half, false);

      var second = half.cloneNode(true);
      second.setAttribute('aria-hidden', 'true');
      Array.prototype.forEach.call(second.querySelectorAll('a'), function (x) {
        x.setAttribute('tabindex', '-1');
      });
      track.appendChild(second);

      var m = medidas();
      var dur = Math.max(14, Math.round(m.halfW / SPEED_PX_S));
      wrap.style.setProperty('--qy-mq-dur', dur + 's');

      if (reduced) {
        track.style.animation = 'none';
      }
    }

    // Ocultar los slides originales del tema (y montar el marquee en su lugar)
    if (slidesBox) slidesBox.style.display = 'none';
    comp.removeAttribute('aria-live');
    slider.appendChild(wrap);

    build();

    // Re-medir cuando las fuentes terminen de cargar (Fraunces cambia anchos)
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function () { build(); });
    }

    window.addEventListener('resize', debounce(build, 300));

    document.addEventListener('visibilitychange', function () {
      wrap.classList.toggle('qy-mq-paused', document.hidden);
    });
  });
})();
